import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./AnimatedText.css";
import { useLanguage } from "../../context/LanguageContext";

const AnimatedText = () => {
  const { t, changeLanguage } = useLanguage();
  const texts = [
    t("animated-category1"),
    t("animated-category2"),
    t("animated-category3"),
    t("animated-category4"),
    t("animated-category5"),
    t("animated-category6"),
  ];

  const swiperRef = useRef(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (swiperRef.current) {
        swiperRef.current.slideNext();
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="animated-text-container">
      <div className="animatex">
        <span className="static-text">{t("animated-text1")}</span> <br />
        <Swiper
          direction="vertical"
          loop={true}
          speed={1800}
          className="animated-text"
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
        >
          {texts.map((text, index) => (
            <SwiperSlide key={index}>
              <div className="animated-word">{text}</div>
            </SwiperSlide>
          ))}
        </Swiper>
        <span className="ml-4 static-text">{t("animated-text2")}</span> <br />
      </div>
      
    </div>
  );
};

export default AnimatedText;
